export const siteConfig = {
  brandName: "tiporchid",
  shortName: "TO",
  logo: {
    src: "/tiporchid-logo.svg",
    alt: "tiporchid",
    ariaLabel: "tiporchid home",
  },
  tagline: "Good design for everyday living.",
  announcement: {
    text: "Tracked shipping is $9.99 per order",
    link: "/shipping",
  },
  description:
    "Thoughtfully designed objects for the small rituals, big days, and everything in between.",
  contact: {
    email: "support@tiporchid.top",
    hours: "Monday–Friday, 9am–5pm ET",
  },
  social: {},
  currency: {
    code: "USD",
    symbol: "$",
    locale: "en-US",
  },
  shipping: {
    standardRate: 9.99,
    localCountries: ["US"],
    regionalCountries: ["CN", "SG", "MY"],
  },
  countryNames: {
    SG: "Singapore",
    CN: "China",
    HK: "Hong Kong SAR",
    MY: "Malaysia",
    AU: "Australia",
    US: "United States",
    GB: "United Kingdom",
  },
  storage: {
    cartKey: "tiporchid.cart",
    wishlistKey: "tiporchid.wishlist",
    orderKey: "tiporchid.lastOrder",
    announcementKey: "tiporchid.announcementDismissed",
    orderPrefix: "TO",
  },
};

export const getShippingRate = () => siteConfig.shipping.standardRate;

export const categories = [
  "All",
  "Bags",
  "Wear",
  "Accessories",
  "Lifestyle",
  "Home & Wellness",
  "Desk & Stationery",
  "Kids",
];

const productImagePair = (id, slug) => {
  const number = String(id).padStart(2, "0");
  const base = `/img/products/p${number}-${slug}`;
  return [`${base}-01.jpg`, `${base}-02.jpg`];
};

const createProduct = ({
  id,
  slug,
  name,
  category,
  price,
  description,
  colors,
  sizes = ["One size"],
  material,
  dimensions,
  care,
  features,
  tags,
  badge = "",
  rating = 4.8,
  reviews = 0,
  featured = false,
}) => {
  const images = productImagePair(id, slug);

  return {
    id,
    slug,
    name,
    brand: siteConfig.brandName,
    category,
    price,
    image: images[0],
    images,
    description,
    attributes: {
      Material: material,
      Dimensions: dimensions,
      Care: care,
    },
    tags,
    colors,
    sizes,
    size: sizes,
    features,
    badge,
    rating,
    reviews,
    featured,
    inStock: true,
  };
};

const productData = [
  createProduct({
    id: 1,
    slug: "drift-puffer-carryall",
    name: "Drift Puffer Carryall",
    category: "Bags",
    price: 129,
    description:
      "An ultra-light carryall with cloud-soft structure and room for a full day out. Wide padded handles sit comfortably on the shoulder while interior pockets keep the small things in place.",
    colors: ["Moss", "Cacao", "Oat"],
    material: "Recycled nylon shell, recycled poly fill",
    dimensions: "42 × 30 × 17 cm · 22 L",
    care: "Spot clean with a soft damp cloth",
    features: [
      "Water-resistant finish",
      "Padded laptop sleeve",
      "Five interior pockets",
    ],
    tags: ["bestseller", "travel", "water-resistant"],
    badge: "Bestseller",
    rating: 4.9,
    reviews: 184,
    featured: true,
  }),
  createProduct({
    id: 2,
    slug: "cove-crescent-sling",
    name: "Cove Crescent Sling",
    category: "Bags",
    price: 72,
    description:
      "A softly curved shoulder bag shaped to sit close to the body. The adjustable strap changes from neat shoulder carry to an easy crossbody in seconds.",
    colors: ["Espresso", "Pulp", "Ink"],
    material: "Recycled nylon with cotton lining",
    dimensions: "31 × 20 × 9 cm · 4.5 L",
    care: "Wipe clean; air dry away from direct heat",
    features: ["Two-way zip", "Adjustable webbing strap", "Internal key clip"],
    tags: ["everyday", "crossbody", "lightweight"],
    badge: "New",
    rating: 4.8,
    reviews: 96,
    featured: true,
  }),
  createProduct({
    id: 3,
    slug: "field-day-tote",
    name: "Field Day Tote",
    category: "Bags",
    price: 96,
    description:
      "A structured canvas tote for workdays, market mornings, and everything after. A full zip keeps the main compartment secure without losing the relaxed shape.",
    colors: ["Oat", "Olive", "Navy"],
    material: "Organic cotton canvas, recycled webbing",
    dimensions: "38 × 29 × 14 cm · 16 L",
    care: "Gentle hand wash in cool water",
    features: [
      "Fits a 14-inch laptop",
      "Three exterior pockets",
      "Full-width top zip",
    ],
    tags: ["work", "canvas", "organisation"],
    rating: 4.8,
    reviews: 73,
    featured: true,
  }),
  createProduct({
    id: 4,
    slug: "cloudline-mini-bucket",
    name: "Cloudline Mini Bucket",
    category: "Bags",
    price: 78,
    description:
      "A compact drawcord bucket bag with a tactile, powder-soft finish. Small in scale but cleverly divided for a phone, cards, keys, and a little more.",
    colors: ["Clay", "Moonbeam", "Fern"],
    material: "Microfiber suede with recycled twill lining",
    dimensions: "19 × 23 × 13 cm · 3.5 L",
    care: "Brush lightly with a clean suede brush",
    features: [
      "Magnetic drawcord guard",
      "Detachable strap",
      "Raised interior pocket",
    ],
    tags: ["mini", "crossbody", "soft-touch"],
    badge: "New",
    rating: 4.7,
    reviews: 41,
    featured: true,
  }),
  createProduct({
    id: 5,
    slug: "weekender-foldall",
    name: "Weekender Foldall",
    category: "Bags",
    price: 148,
    description:
      "A roomy, fold-flat weekender with a wide opening and a separate base pocket for shoes or laundry. Designed to feel light even when the itinerary is full.",
    colors: ["Ink", "Canyon", "Moss"],
    material: "Recycled ripstop nylon",
    dimensions: "52 × 34 × 22 cm · 34 L",
    care: "Cold hand wash; reshape and line dry",
    features: [
      "Trolley sleeve",
      "Removable shoulder strap",
      "Separate base compartment",
    ],
    tags: ["travel", "weekend", "foldable"],
    rating: 4.9,
    reviews: 122,
    featured: true,
  }),
  createProduct({
    id: 6,
    slug: "parcel-crossbody",
    name: "Parcel Crossbody",
    category: "Bags",
    price: 69,
    description:
      "A neat, boxy crossbody built around the essentials. The double-zip opening reveals two calm compartments so nothing disappears at the bottom.",
    colors: ["Sage", "Coffee", "Saffron"],
    material: "Recycled nylon and brushed cotton lining",
    dimensions: "22 × 15 × 8 cm · 2.3 L",
    care: "Spot clean only",
    features: ["Dual compartments", "Back slip pocket", "Quick-adjust strap"],
    tags: ["compact", "organisation", "everyday"],
    rating: 4.7,
    reviews: 68,
    featured: true,
  }),
  createProduct({
    id: 7,
    slug: "loop-utility-pouch",
    name: "Loop Utility Pouch",
    category: "Accessories",
    price: 45,
    description:
      "A cheerful little organizer for cables, cosmetics, stationery, or travel odds and ends. The side loop clips easily into a larger bag.",
    colors: ["Butter", "Paprika", "Pine"],
    material: "Recycled mini-ripstop nylon",
    dimensions: "18 × 11 × 7 cm",
    care: "Wipe clean",
    features: ["Padded walls", "Mesh divider", "Clip-ready side loop"],
    tags: ["pouch", "gifting", "organisation"],
    badge: "Gift pick",
    rating: 4.8,
    reviews: 89,
    featured: true,
  }),
  createProduct({
    id: 8,
    slug: "ripple-laptop-sleeve",
    name: "Ripple Laptop Sleeve",
    category: "Accessories",
    price: 52,
    description:
      "A softly padded sleeve with a rippled quilt and a hidden document pocket. Protective enough for the commute, slim enough to slip inside a tote.",
    colors: ["Cocoa", "Stone", "Lake"],
    sizes: ["13 inch", "15 inch"],
    material: "Recycled nylon, plant-based foam padding",
    dimensions: "Available for 13-inch and 15-inch devices",
    care: "Spot clean and air dry",
    features: ["Soft brushed lining", "Hidden rear pocket", "Two-way zip"],
    tags: ["tech", "work", "padded"],
    rating: 4.8,
    reviews: 57,
  }),
  createProduct({
    id: 9,
    slug: "airweave-resort-shirt",
    name: "Airweave Resort Shirt",
    category: "Wear",
    price: 59,
    description:
      "An easy camp-collar shirt in airy, subtly textured cotton. Cut with a relaxed unisex shape that works buttoned, open, or tucked.",
    colors: ["Shell", "Cypress", "Sunset"],
    sizes: ["XS", "S", "M", "L", "XL"],
    material: "100% organic crinkle cotton",
    dimensions: "Relaxed unisex fit",
    care: "Machine wash cold; line dry",
    features: ["Breathable weave", "Coconut-shell buttons", "Side-seam vents"],
    tags: ["resort", "unisex", "breathable"],
    badge: "New",
    rating: 4.7,
    reviews: 38,
  }),
  createProduct({
    id: 10,
    slug: "easy-barrel-trousers",
    name: "Easy Barrel Trousers",
    category: "Wear",
    price: 68,
    description:
      "Relaxed pull-on trousers with a gentle barrel leg and a clean, cropped finish. The lightweight twill moves easily from slow mornings to busy afternoons.",
    colors: ["Fern", "Oat", "Ebony"],
    sizes: ["XS", "S", "M", "L", "XL"],
    material: "Cotton-TENCEL™ twill",
    dimensions: "High rise · cropped ankle",
    care: "Machine wash cold with like colours",
    features: ["Elastic back waist", "Deep side pockets", "Soft garment wash"],
    tags: ["everyday", "relaxed", "soft-tailoring"],
    rating: 4.8,
    reviews: 64,
  }),
  createProduct({
    id: 11,
    slug: "sunroom-wrap-dress",
    name: "Sunroom Wrap Dress",
    category: "Wear",
    price: 79,
    description:
      "A light midi dress that wraps, ties, and adjusts with the day. Wide shoulder ties and a softly gathered skirt make it equally easy over swimwear or dressed up for dinner.",
    colors: ["Terracotta", "Regatta", "Sand"],
    sizes: ["XS", "S", "M", "L", "XL"],
    material: "Linen-viscose blend",
    dimensions: "Midi length · adjustable wrap fit",
    care: "Gentle cold wash; steam to reshape",
    features: [
      "Adjustable waist tie",
      "Side pockets",
      "Partially lined bodice",
    ],
    tags: ["resort", "summer", "adjustable"],
    rating: 4.8,
    reviews: 46,
  }),
  createProduct({
    id: 12,
    slug: "weekend-camp-cap",
    name: "Weekend Camp Cap",
    category: "Wear",
    price: 45,
    description:
      "A five-panel cap with an unstructured crown and just enough shade. Lightweight cotton ripstop packs easily without losing its shape.",
    colors: ["Walnut", "Iris", "Olive"],
    sizes: ["One size"],
    material: "Organic cotton ripstop",
    dimensions: "Adjustable 54–61 cm circumference",
    care: "Hand wash and reshape while damp",
    features: [
      "Low-profile fit",
      "Brass slide adjuster",
      "Embroidered eyelets",
    ],
    tags: ["outdoor", "packable", "unisex"],
    rating: 4.6,
    reviews: 34,
  }),
  createProduct({
    id: 13,
    slug: "tide-reusable-bag",
    name: "Tide Reusable Bag",
    category: "Lifestyle",
    price: 45,
    description:
      "A dependable reusable bag that folds into its own pocket. Broad handles sit comfortably on the shoulder, even after an ambitious market run.",
    colors: ["Check Olive", "Stripe Clay", "Speckle Navy"],
    sizes: ["Mini", "Regular"],
    material: "100% recycled polyester",
    dimensions: "Regular: 46 × 41 cm · Mini: 34 × 31 cm",
    care: "Machine wash cold; hang dry",
    features: [
      "Self-storing pocket",
      "Reinforced seams",
      "Carries up to 15 kg",
    ],
    tags: ["reusable", "sustainable", "packable"],
    badge: "Everyday essential",
    rating: 4.9,
    reviews: 211,
  }),
  createProduct({
    id: 14,
    slug: "pocket-bottle-sling",
    name: "Pocket Bottle Sling",
    category: "Accessories",
    price: 48,
    description:
      "A cushioned bottle carrier with a phone pocket and a softly adjustable strap. Made for neighbourhood walks, travel days, and hands-free hydration.",
    colors: ["Sand", "Moss", "Berry"],
    sizes: ["Regular", "Large"],
    material: "Recycled padded nylon",
    dimensions: "Fits bottles up to 9 cm diameter",
    care: "Wipe clean",
    features: ["Insulated lining", "Phone slip pocket", "Removable strap"],
    tags: ["outdoor", "bottle", "hands-free"],
    rating: 4.7,
    reviews: 75,
  }),
  createProduct({
    id: 15,
    slug: "daybreak-thermal-bottle",
    name: "Daybreak Thermal Bottle",
    category: "Lifestyle",
    price: 52,
    description:
      "A slim insulated bottle with a rounded cap and a powder-soft finish. Keeps water cold through the commute and tea warm through a slow afternoon.",
    colors: ["Apricot", "Chamomile", "Deep Sea"],
    sizes: ["500 ml", "750 ml"],
    material: "Double-wall stainless steel, BPA-free silicone",
    dimensions: "500 ml: 6.8 × 23.5 cm",
    care: "Hand wash; do not microwave",
    features: [
      "Leak-resistant cap",
      "Wide ice-friendly opening",
      "12-hour temperature hold",
    ],
    tags: ["drinkware", "commute", "reusable"],
    rating: 4.8,
    reviews: 103,
  }),
  createProduct({
    id: 16,
    slug: "cloud-rest-travel-pillow",
    name: "Cloud Rest Travel Pillow",
    category: "Lifestyle",
    price: 48,
    description:
      "A supportive travel pillow that compresses into a tidy pouch. The asymmetric shape supports the chin without feeling bulky at the back of the neck.",
    colors: ["Oat", "Sage", "Cocoa"],
    material: "Recycled microfibre cover, memory foam core",
    dimensions: "28 × 27 × 10 cm",
    care: "Remove cover and machine wash cold",
    features: [
      "Packable carry pouch",
      "Snap closure",
      "Removable washable cover",
    ],
    tags: ["travel", "comfort", "packable"],
    rating: 4.7,
    reviews: 29,
  }),
  createProduct({
    id: 17,
    slug: "nest-packing-cube-set",
    name: "Nest Packing Cube Set",
    category: "Lifestyle",
    price: 55,
    description:
      "Three softly structured packing cubes that nest neatly between trips. Breathable mesh windows make it easy to spot what belongs where.",
    colors: ["Moss", "Dusk", "Papaya"],
    material: "Recycled ripstop and mesh",
    dimensions: "Small, medium, and large set",
    care: "Hand wash; air dry fully before storing",
    features: [
      "Double zip openings",
      "Breathable mesh panels",
      "Nest together for storage",
    ],
    tags: ["travel", "organisation", "set"],
    rating: 4.8,
    reviews: 81,
  }),
  createProduct({
    id: 18,
    slug: "quiet-time-journal",
    name: "Quiet Time Journal",
    category: "Desk & Stationery",
    price: 45,
    description:
      "A clothbound guided journal with gentle prompts for noticing, reflecting, and resetting. Undated pages make it easy to begin exactly where you are.",
    colors: ["Sienna", "Forest", "Mist"],
    material: "FSC-certified paper, cotton book cloth",
    dimensions: "A5 · 192 pages",
    care: "Keep dry and away from direct sunlight",
    features: ["Undated prompts", "Lay-flat binding", "Two ribbon markers"],
    tags: ["wellness", "journal", "gifting"],
    badge: "Gift pick",
    rating: 4.9,
    reviews: 146,
  }),
  createProduct({
    id: 19,
    slug: "undated-weekly-planner",
    name: "Undated Weekly Planner",
    category: "Desk & Stationery",
    price: 46,
    description:
      "A flexible twelve-month planner with just enough structure. Weekly spreads pair practical lists with open space for notes, sketches, and changing plans.",
    colors: ["Fog", "Olive", "Canyon"],
    material: "FSC-certified paper, recycled board cover",
    dimensions: "18.5 × 24 cm · 160 pages",
    care: "Keep dry",
    features: [
      "52 undated weeks",
      "Monthly overview pages",
      "Back storage pocket",
    ],
    tags: ["planner", "work", "organisation"],
    rating: 4.8,
    reviews: 118,
  }),
  createProduct({
    id: 20,
    slug: "desk-reset-tray",
    name: "Desk Reset Tray",
    category: "Desk & Stationery",
    price: 49,
    description:
      "A modular desk tray with shaped spaces for pens, clips, cards, and a phone. Its soft stone finish brings visual calm without asking the desk to stay perfect.",
    colors: ["Stone", "Clay", "Charcoal"],
    material: "Recycled paper composite",
    dimensions: "30 × 18 × 3 cm",
    care: "Wipe with a dry or lightly damp cloth",
    features: [
      "Four shaped compartments",
      "Non-slip cork base",
      "Stackable profile",
    ],
    tags: ["desk", "organisation", "home-office"],
    rating: 4.6,
    reviews: 27,
  }),
  createProduct({
    id: 21,
    slug: "slow-morning-mug",
    name: "Slow Morning Mug",
    category: "Home & Wellness",
    price: 45,
    description:
      "A generous stoneware mug with a softly pinched handle and a satin cocoa glaze. Each piece carries small variations from the hands that finished it.",
    colors: ["Cocoa", "Oat", "Moss"],
    material: "High-fired stoneware",
    dimensions: "350 ml · 9 × 8.5 cm",
    care: "Dishwasher and microwave safe",
    features: [
      "Hand-finished glaze",
      "Comfortable wide handle",
      "Food-safe finish",
    ],
    tags: ["ceramic", "ritual", "gifting"],
    rating: 4.9,
    reviews: 91,
  }),
  createProduct({
    id: 22,
    slug: "balance-candle",
    name: "Balance Candle",
    category: "Home & Wellness",
    price: 48,
    description:
      "A clean-burning candle layered with hinoki, soft moss, and dry cedar. The quiet woody scent is designed for evening resets and unhurried rooms.",
    colors: ["Hinoki", "Fig Leaf", "Tea Wood"],
    material: "Coconut-soy wax, cotton wick, reusable glass",
    dimensions: "220 g · approximately 48 hours burn time",
    care: "Trim wick to 5 mm before each burn",
    features: [
      "Phthalate-free fragrance",
      "Lead-free cotton wick",
      "Reusable vessel",
    ],
    tags: ["wellness", "home", "gifting"],
    rating: 4.8,
    reviews: 66,
  }),
  createProduct({
    id: 23,
    slug: "soft-landing-throw",
    name: "Soft Landing Throw",
    category: "Home & Wellness",
    price: 74,
    description:
      "A lightly textured cotton throw woven for year-round comfort. The subtle two-tone weave looks composed on a sofa and feels even better wrapped around the shoulders.",
    colors: ["Sage", "Canyon", "Natural"],
    material: "100% recycled cotton",
    dimensions: "130 × 180 cm",
    care: "Machine wash gentle; tumble dry low",
    features: [
      "Reversible two-tone weave",
      "Twisted fringe",
      "Midweight year-round feel",
    ],
    tags: ["home", "textile", "sustainable"],
    rating: 4.7,
    reviews: 33,
  }),
  createProduct({
    id: 24,
    slug: "little-explorer-mini-pack",
    name: "Little Explorer Mini Pack",
    category: "Kids",
    price: 54,
    description:
      "A small, lightweight backpack for big little plans. Rounded straps, an easy zip, and a bright lining help young explorers carry their own treasures.",
    colors: ["Ochre", "Lake", "Berry"],
    sizes: ["Mini"],
    material: "Recycled water-resistant nylon",
    dimensions: "24 × 29 × 10 cm · 6 L",
    care: "Spot clean and air dry",
    features: [
      "Padded adjustable straps",
      "Easy-grip zip pulls",
      "Name card pocket inside",
    ],
    tags: ["kids", "mini", "outdoor"],
    badge: "Mini",
    rating: 4.9,
    reviews: 52,
  }),
  createProduct({
    id: 25,
    slug: "calm-grid-travel-organiser",
    name: "Calm Grid Travel Organiser",
    category: "Accessories",
    price: 58,
    description:
      "A softly quilted organiser that keeps cables, small toiletries, and daily essentials visible and easy to reach. The book-style opening and four mesh pockets make packing feel orderly without adding bulk.",
    colors: ["Taupe", "Olive", "Ink"],
    material: "Recycled quilted nylon with mesh lining",
    dimensions: "24 × 16 × 7 cm",
    care: "Wipe clean and air dry",
    features: ["Book-style opening", "Four mesh pockets", "Two-way zip"],
    tags: ["travel", "organisation", "everyday"],
    badge: "New",
    rating: 4.8,
    reviews: 18,
    featured: true,
  }),
];

export const formatPrice = (price) =>
  new Intl.NumberFormat(siteConfig.currency.locale, {
    style: "currency",
    currency: siteConfig.currency.code,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 2,
  })
    .format(price)
    .replace(/^\$/, siteConfig.currency.symbol);

export default productData;
